import { Separator } from 'components/common/Separator'
import { Step } from 'components/common/Step'
import { ComponentProps, Fragment } from 'react'

type Props = {
  className?: string
  steps: ComponentProps<typeof Step>[]
  stepClassName?: string
  dark?: boolean
}

export const Stepper = ({ steps, className, stepClassName, dark }: Props) => {
  return (
    <ol className={className}>
      {steps.map((step, index) => (
        <Fragment key={index}>
          <Step className={stepClassName} dark={dark} {...step} />
          {index !== steps.length - 1 && <Separator className='my-6' />}
        </Fragment>
      ))}
    </ol>
  )
}
